import type { MountPoint } from "./types";

type Listener = () => void;

const mountPoints = new Map<HTMLElement, MountPoint>();
const listeners = new Set<Listener>();

let snapshot: MountPoint[] = [];
let snapshotDirty = false;
let notifyScheduled = false;

// A microtask runs before the browser paints
function scheduleNotify(): void {
  snapshotDirty = true;

  if (notifyScheduled) {
    return;
  }

  notifyScheduled = true;

  queueMicrotask(() => {
    notifyScheduled = false;

    listeners.forEach((listener) => listener());
  });
}

// Registers (or updates) a mount point for custom element
export function registerMountPoint(mountPoint: MountPoint): void {
  mountPoints.set(mountPoint.el, mountPoint);
  scheduleNotify();
}

// Removes a mount point, e.g. when its custom element leaves the DOM
export function unregisterMountPoint(el: HTMLElement): void {
  if (mountPoints.delete(el)) {
    scheduleNotify();
  }
}

export function subscribeMountPoints(listener: Listener): () => void {
  listeners.add(listener);

  return () => listeners.delete(listener);
}

// Rebuilt lazily (not in scheduleNotify)
export function getMountPointsSnapshot(): MountPoint[] {
  if (snapshotDirty) {
    snapshot = Array.from(mountPoints.values());
    snapshotDirty = false;
  }

  return snapshot;
}
